import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardTitle, Col, Row } from 'reactstrap';
import { MaterialIcon, PageHeader, UserStateComponent } from '../../components';
import { isResourceError } from '../../utils';
import { LoadingWrapper } from '../../utils/LoadingWrapper';

interface ChangeEmailComponentProps {
  readonly match: {
    params: {
      code?: string;
    };
  };
}

export class ChangeEmailComponent extends Component<ChangeEmailComponentProps> {
  public override render(): JSX.Element {
    return (
      <UserStateComponent>
        <PageHeader>Account Change Email</PageHeader>
        <Row className="justify-content-center">
          <Col lg={6} xs={12}>
            <Card>
              <CardBody className="text-center">
                <LoadingWrapper<void, void>
                  dataFetcher={async () =>
                    await api.confirmChangeEmail(this.props.match.params.code ?? '')
                  }
                  errorDisplay={(err) => isResourceError(err, 'User') && this.showError()}
                  loadingDisplay={() => this.showLoading()}
                >
                  {() => this.showUpdated()}
                </LoadingWrapper>
                <hr />
                <Link className="btn btn-link btn-block" to="/">
                  Go back to homepage
                </Link>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </UserStateComponent>
    );
  }

  private showLoading(): JSX.Element {
    return (
      <div id="confirmLoading">
        <MaterialIcon className="margin-bottom-10" large name="security" type="muted" />
        <CardTitle>Just a Moment...</CardTitle>
        <p>We are checking the email change request. This may take a few moments.</p>
      </div>
    );
  }

  private showUpdated(): JSX.Element {
    return (
      <div id="confirmUpdated">
        <MaterialIcon className="margin-bottom-10" large name="verified_user" type="success" />
        <CardTitle>Email updated!</CardTitle>
        <p>Your email address has been updated!</p>
      </div>
    );
  }

  private showError(): JSX.Element {
    return (
      <div id="confirmError">
        <MaterialIcon className="margin-bottom-10" large name="warning" type="warning" />
        <CardTitle>Error During Activation</CardTitle>
        <p>Sorry, but the code you provided could not be matched with any email change requests.</p>
        <p>
          Try copying the activation link from your mail client and pasting it into the address bar.
        </p>
      </div>
    );
  }
}
